import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import "./style.css"; // Import CSS for styling

const ThankYouInvoicePage = () => {
  return (
    <Container>
      <Row className="main-row w-100 justify-content-center align-items-center">
        <Col className="d-flex justify-content-center align-items-center flex-column mt-5">
          <FontAwesomeIcon
            icon={faCheckCircle}
            className="color-primary"
            style={{ fontSize: 100 }}
          />
          <h1 className="mt-4">Thank You</h1>
          <p>
            Thank you for submitting. You will receive an email shortly with the
            invoice PDF.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export { ThankYouInvoicePage };
